module.exports = __webpack_public_path__ + "img/elsa_favicon-16x16.258358df.png";